import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RastreadorService {
  private url_grupo_2e: string = environment.g2e_api;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
    }),
  }

  constructor(private http: HttpClient) { }

  public async post(data: any): Promise<any> {
    return await this.http
      .post<any>(`${this.url_grupo_2e}rastreador`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async get(): Promise<Array<any>> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async getOne(id: number): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async patch(data: any, id: number): Promise<any> {
    return await this.http
      .patch<any>(`${this.url_grupo_2e}rastreador/${id}`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async delete(id: number): Promise<any> {
    return await this.http
      .delete<any>(`${this.url_grupo_2e}rastreador/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async entradaRastreador(data: any): Promise<any> {
    return await this.http
      .post<any>(`${this.url_grupo_2e}rastreador/entrada`, data, this.httpOptions)
      .pipe(
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async listarLoteEntradaRastreador(data: any): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador/entrada`, this.httpOptions)
      .pipe(
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async getOneEntrada(id: number): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador/entrada/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async getPaginated(page: number = 1, limit: number = 10): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador?page=${page}&limit=${limit}`, this.httpOptions)
      .pipe(
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async search(
    imei?: string,
    modelo?: string,
    estoque?: string,
    status?: number,
    page: number = 1,
    limit: number = 10
  ): Promise<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (imei) params = params.set('imei', imei);
    if (modelo) params = params.set('modelo', modelo);
    if (estoque) params = params.set('estoque', estoque);
    if (status) params = params.set('status', status.toString());

    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador/search`, {
        headers: this.httpOptions.headers,
        params: params
      })
      .pipe(
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }
}
